import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTenant } from '../context/TenantContext';
import { goTo } from '../lib/host';
import { usePlanLabel } from '../lib/usePlans';
import '../pages/AdminDashboard.css';
import './Layout.css';
import NotificationBell from './notifications/NotificationBell';

const NAV = [
  { to: '/', label: 'Overview', perm: 'tenant.read', end: true },
  { to: '/members', label: 'Members', perm: 'members.read' },
  { to: '/settings', label: 'Settings', perm: 'settings.write' },
  { to: '/subscription', label: 'Billing', perm: 'billing.manage' },
];

export default function TenantLayout() {
  const planLabel = usePlanLabel();
  const { user, logout } = useAuth();
  const { tenant, role, can } = useTenant();

  const handleLogout = async () => {
    await logout();
    goTo('/login');  // this company's own login page
  };

  return (
    <div className="admin-container">
      <header className="admin-header">
        <div className="tcx-header-left">
          <h1>{tenant.name}</h1>
          <span className="admin-badge">{planLabel(tenant.plan)}</span>
        </div>
        <div className="admin-header-right">
          <NotificationBell className="admin-bell" />
          <span className="admin-name">{user.name}</span>
          <span className={`tcx-role tcx-role-${role}`}>{role}</span>
          <button onClick={handleLogout} className="admin-logout-btn">Logout</button>
        </div>
      </header>

      <div className="admin-body">
        <aside className="admin-sidebar">
          <nav>
            <ul>
              {NAV.filter((n) => can(n.perm)).map((n) => (
                <li key={n.to} className="tcx-nav-item">
                  <NavLink to={n.to} end={n.end}>{n.label}</NavLink>
                </li>
              ))}
            </ul>
          </nav>
        </aside>
        <main className="admin-main">
          <Outlet />
        </main>
      </div>

      <footer className="admin-footer">
        <p>© {new Date().getFullYear()} TelecalX · {tenant.slug}</p>
      </footer>
    </div>
  );
}
